import { ApiService } from "./ApiService"

export class InvoiceTransactionService {

    static uri = '/invoice-transaction';

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}